import {
    Component,
    ElementRef,
    EventEmitter,
    Injector,
    OnInit,
    Output,
} from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { AppComponentBase } from "@shared/common/app-component-base";

export interface ITransaction {
    cupomFiscal: string | undefined;
    empresa: string | undefined;
    sitefIp: string | undefined;
    terminal: string | undefined;
    initialParams: string | undefined;
}

@Component({
    selector: "agent-sitef",
    templateUrl: "./agent-sitef.component.html",
    styleUrls: ["./agent-sitef.component.css"],
})
export class AgentSitefComponent extends AppComponentBase implements OnInit {
    @Output() finishTransaction: EventEmitter<any> = new EventEmitter<any>();

    private _agent_url = "https://127.0.0.1/agente/clisitef"; //URL do agente instalado e configurado na máquina local
    private _sessao: any = {};

    public _processing: boolean;
    public _statusAgent: string = "Conectando Agente...";
    public _commandId: any = undefined;
    public _statusTitle: string = "";
    public _statusBody: any = "";
    public _paymentIcon: string = "/assets/common/images/processando.png";

    private iconInterrogacao = "/assets/common/images/interrogacao.png";
    private iconOperacaoCancelada =
        "/assets/common/images/operacao-cancelada.png";
    private iconProcessandoCartao = "/assets/common/images/card-proccess.png";
    private iconSelecioneCartao = "/assets/common/images/card-select.png";
    private iconRetiraCartao = "/assets/common/images/retire-cartao.png";
    private iconInsiraCartao = "/assets/common/images/insira-cartao.png";
    private iconProcessando = "/assets/common/images/processando.png";
    private iconConectando = "/assets/common/images/conectando-servidor.png";
    private iconConectado = "/assets/common/images/servidor-conectado.png";
    private iconSenha = "/assets/common/images/digite-senha.png";

    private iconAprovado = "/assets/common/images/compra-aprovada.png";

    private cupomFiscal: string = "";
    private empresa: string = "";
    private terminal: string = "";
    private parcelas: number = 1;
    private initialParams: string = "";
    private sitefIp: string = "";

    constructor(
        injector: Injector,
        private sanitized: DomSanitizer,
        private elementRef: ElementRef
    ) {
        super(injector);
    }

    ngOnInit() {
        //this.getStatusAgent();
        // this.createSessionId("192.168.40.13", "00000000", "TERMINAL 01 - COPA 2024", "ParmsClient=1=63060396000182;2=04872406000115");
        // var $this = this;
        // setTimeout(function(){
        //     $this.pinpadPresent();
        //     $this.pinpadMensagem("SAESP COPA 2024", undefined);
        // }, 2000)
    }

    getStatusAgent(): void {
        var $this = this;

        $this.showStatus("Conectando Agente...");

        $.ajax({
            url: this._agent_url + "/state",
            type: "get",
            data: {},
        })
            .done(function (data) {
                if (data.serviceStatus == 0) {
                    var s =
                        "Vers&atilde;o do agente: [" +
                        data.serviceVersion +
                        "]<br/><br/>" +
                        data.serviceState;

                    if (data.serviceState == 0) s = s + " - não inicializado.";
                    else if (data.serviceState == 1)
                        s =
                            s +
                            " - agente pronto para receber solicita&ccedil;&otilde;es.";
                    else if (data.serviceState == 2)
                        s =
                            s +
                            " - IniciaFuncaoSiTefInterativo iniciado com sucesso - aguardando continua.";
                    else if (data.serviceState == 3)
                        s =
                            s +
                            " - processo iterativo da clisitef em andamento - aguardando continua.";
                    else if (data.serviceState == 4)
                        s = s + " - aguardando finaliza.";

                    if (data.sessionId)
                        s =
                            s +
                            "<br/><br/>Sess&atilde;o atual [" +
                            data.sessionId +
                            "]";

                    $this.showStatus(s);
                } else {
                    $this.showMessage(
                        data.serviceStatus + " - " + data.serviceMessage
                    );
                }
            })
            .fail(function (xhr, ajaxOptions, thrownError) {
                $this.showMessage(
                    `Erro: ${xhr.status} - ${thrownError} <br> ${xhr.responseText}`
                );
            });
    }

    // ===========================================================================
    // Funcoes para gerenciamento de Sessao: Criar/Finalizar, consultar sessão atual

    createSessionId(
        sitefIp: string,
        enterprise: string,
        terminal: string,
        sessionparams: string
    ) {
        var $this = this;
        var ret = [];
        $this._sessao.ret = ret;
        $this._sessao.continua = 0;
        $this._sessao.cupomFiscal = "";
        $this._sessao.dataFiscal = this.getCurrentDateNums();
        $this._sessao.horaFiscal = this.getCurrentTimeNums();

        $this.showStatus("Criando sessao...");

        $.ajax({
            url: $this._agent_url + "/session",
            type: "post",
            data: {
                sitefIp: sitefIp,
                storeId: enterprise,
                terminalId: terminal,
                sessionParameters: sessionparams,
            },
        })
            .done(function (data) {
                if (data.serviceStatus == 0) {
                    // Salva a sessionId e dados da conexao
                    $this._sessao.sessionId = data.sessionId;
                    $this._sessao.usandoSessao = 1;
                    $this._sessao.empresa = enterprise;
                    $this._sessao.terminal = terminal;
                    $this._sessao.siTefIP = sitefIp;

                    $this.showMessage("Sessão criada [" + data.sessionId + "]");
                } else {
                    $this.showMessage(
                        data.serviceStatus + " - " + data.serviceMessage
                    );
                }
            })
            .fail(function (xhr, ajaxOptions, thrownError) {
                $this.showMessage(
                    `Erro: ${xhr.status} - ${thrownError} <br> ${xhr.responseText}`
                );
            });
    }

    destroiSessaoId(): void {
        var $this = this;
        var ret = [];
        $this._sessao.ret = ret;
        $this._sessao.continua = 0;
        $this._sessao.cupomFiscal = "";
        $this._sessao.dataFiscal = this.getCurrentDateNums();
        $this._sessao.horaFiscal = this.getCurrentTimeNums();

        $this.showStatus("Finalizando sessao");

        $.ajax({
            url: $this._agent_url + "/session",
            type: "delete",
            //data:{
            //	"sessionId":sessao.sessionId,
            //},
        })
            .done(function (data) {
                if (data.serviceStatus == 0) {
                    $this.showMessage("Sessao finalizada");
                } else {
                    $this.showMessage(
                        data.serviceStatus + " - " + data.serviceMessage
                    );
                }
            })
            .fail(function (xhr, ajaxOptions, thrownError) {
                $this.showMessage(
                    `Erro: ${xhr.status} - ${thrownError} <br> ${xhr.responseText}`
                );
            });

        // Limpa a sessionId, independente de ter dado erro.
        $this._sessao.sessionId = "";
        $this._sessao.usandoSessao = 0;
    }

    getSessaoId() {
        var $this = this;
        $this.showStatus("Obtendo sessao...");

        $.ajax({
            url: $this._agent_url + "/session",
            type: "get",
            data: {},
        })
            .done(function (data) {
                if (data.serviceStatus == 0) {
                    // Salva a sessionId
                    $this._sessao.sessionId = data.sessionId;
                    $this._sessao.usandoSessao = 1;
                    $this.showMessage(data.sessionId);
                } else {
                    $this.showMessage(
                        data.serviceStatus + " - " + data.serviceMessage
                    );
                }
            })
            .fail(function (xhr, ajaxOptions, thrownError) {
                $this.showMessage(
                    `Erro: ${xhr.status} - ${thrownError} <br> ${xhr.responseText}`
                );
            });
    }

    // ===========================================================================
    // Funções gerais

    getVersions() {
        var $this = this;
        $this.showStatus("Obtendo versão...");

        $.ajax({
            url: this._agent_url + "/getVersion",
            type: "post",
            data: {
                sessionId: this._sessao.sessionId,
            },
        })
            .done(function (data) {
                if (data.serviceStatus == 0) {
                    $this.showMessage(
                        "CliSiTef: [" +
                            data.clisitefVersion +
                            "]<br/>CliSiTefI: [" +
                            data.clisitefiVersion +
                            "]<br/>AgenteCliSiTef: [" +
                            data.serviceVersion +
                            "]"
                    );
                } else {
                    $this.showMessage(
                        data.serviceStatus + " - " + data.serviceMessage
                    );
                }
            })
            .fail(function (xhr, ajaxOptions, thrownError) {
                $this.showMessage(
                    `Erro: ${xhr.status} - ${thrownError} <br> ${xhr.responseText}`
                );
            });
    }

    // ===========================================================================
    // TEF
    // tipo = 1 - Venda simples: a sessão é criada internamente e destruida no final
    // tipo = 2 - Venda com sessão: usa-se a sessão criada previamente pela automção
    // funcao - código da função na IniciaFuncaoSiTefInterativo
    start(
        tipo: number,
        funcao: number,
        cupomFiscal: any,
        value: any,
        parcelas: number,
        operator: string,
        trnParams: string,
        sessionParams: string,
        sitefIp: string,
        empresa: string,
        terminal: string
    ) {
        var $this = this;
        var ret = [];
        $this._sessao.ret = ret;
        $this._sessao.continua = 0;
        $this._sessao.cupomFiscal = cupomFiscal;
        $this._sessao.dataFiscal = this.getCurrentDateNums();
        $this._sessao.horaFiscal = this.getCurrentTimeNums();
        $this.parcelas = parcelas;

        $this.cupomFiscal = cupomFiscal;
        $this.sitefIp = sitefIp;
        $this.empresa = empresa;
        $this.terminal = terminal;
        $this.parcelas = parcelas;
        $this.initialParams = sessionParams;

        $this._processing = true;
        $this.showStatus("Iniciando transação...");

        var args: any = {};
        if (tipo == 1) {
            // Envia dados para uma nova sessão
            args.sitefIp = sitefIp;
            args.storeId = empresa;
            args.terminalId = terminal;
        } else if (tipo == 2 && $this._sessao.sessionId) {
            args.sessionId = $this._sessao.sessionId;
        }

        // Argumentos comuns
        args.functionId = funcao;
        args.trnAmount = value;
        args.taxInvoiceNumber = cupomFiscal;
        args.taxInvoiceDate = $this._sessao.dataFiscal;
        args.taxInvoiceTime = $this._sessao.horaFiscal;
        args.cashierOperator = operator;
        args.trnAdditionalParameters = trnParams;
        args.trnInitParameters = sessionParams;

        $.ajax({
            url: $this._agent_url + "/startTransaction",
            type: "post",
            data: jQuery.param(args),
        })
            .done(function (data) {
                if (data.serviceStatus != 0) {
                    $this.showMessage(
                        `Agente ocupado: ${data.serviceStatus} ${data.serviceMessage}`
                    );
                } else if (data.clisitefStatus != 10000) {
                    $this.showMessage(
                        `Retorno ${data.clisitefStatus} da CliSiTef`
                    );
                } else {
                    // Inicia retornou 10000 (via clisitef)
                    $this._sessao.continua = 0;

                    // Salva a sessionId para usar na confirmacao
                    $this._sessao.sessionId = data.sessionId;

                    // Continua no fluxo de coleta
                    $this.continue("");
                }
            })
            .fail(function (xhr, ajaxOptions, thrownError) {
                $this.showMessage(
                    `Erro: ${xhr.status} - ${thrownError} <br> ${xhr.responseText}`
                );
            });
    }

    finish(
        confirma,
        reenviaParametrosSiTef,
        foraDoFluxo,
        cupomFiscal,
        sitefIp,
        empresa,
        terminal,
        sessionParams
    ) {
        var $this = this;
        var args: any = {
            confirm: confirma,
        };

        if (reenviaParametrosSiTef) {
            args.sitefIp = sitefIp;
            args.storeId = empresa;
            args.terminalId = terminal;
            args.taxInvoiceNumber = cupomFiscal;
            args.taxInvoiceDate =
                $this._sessao.dataFiscal || $this.getCurrentDateNums();
            args.taxInvoiceTime =
                $this._sessao.horaFiscal || $this.getCurrentTimeNums();
            args.trnInitParameters = sessionParams;
        } else {
            args.sessionId = $this._sessao.sessionId;
            args.taxInvoiceNumber = $this._sessao.cupomFiscal || cupomFiscal;
            args.taxInvoiceDate =
                $this._sessao.dataFiscal || $this.getCurrentDateNums();
            args.taxInvoiceTime =
                $this._sessao.horaFiscal || $this.getCurrentTimeNums();
            args.trnInitParameters = sessionParams;
        }

        $.ajax({
            url: $this._agent_url + "/finishTransaction",
            type: "post",
            data: args,
        })
            .done(function (data) {
                if (data.serviceStatus != 0) {
                    $this.message.info(data.serviceMessage, data.serviceStatus);
                    location.reload();
                } else {
                    if (foraDoFluxo) {
                        $this.showStatus("Finalizando Transação");
                        $this.showMessage(
                            `serviceStatus: ${data.serviceStatus}  <br> clisitefStatus: ${data.clisitefStatus}`
                        );
                    }
                }
            })
            .fail(function (xhr, ajaxOptions, thrownError) {
                $this.showStatus(
                    `Erro: ${xhr.status} - ${thrownError} <br> ${xhr.responseText}`
                );
            });
    }

    continue(dados) {
        var $this = this;
        // lembrete: chamada ajax é assincrona, então sai da função continua imediatamente]
        $.ajax({
            url: $this._agent_url + "/continueTransaction",
            type: "post",
            data: {
                sessionId: $this._sessao.sessionId,
                data: dados,
                continue: $this._sessao.continua,
            },
        })
            .done(function (data) {
                /*console.log("Continua Status=" + data.clisitefStatus +
                " Dados=" + data.data +
                " Comando=" + data.commandId +
                " TipoCampo=" + data.fieldId +
                " TamMin=" + data.fieldMinLength +
                " TamMax=" + data.fieldMaxLength);*/

                if (data.serviceStatus != 0) {
                    $this.showMessage(
                        data.serviceStatus + " " + data.serviceMessage
                    );
                    return;
                }

                if (data.clisitefStatus != 10000) {
                    var s = "";

                    if (data.clisitefStatus == 0) {
                        s = JSON.stringify($this._sessao.ret);
                        s = s.replace(/},{/g, "},<br>{");

                        localStorage.setItem("dadosSitef", s);
                        $this.showStatus("Finalizando, aguarde...");

                        $this.finish(
                            1,
                            false,
                            false,
                            $this.cupomFiscal,
                            $this.sitefIp,
                            $this.empresa,
                            $this.terminal,
                            $this.initialParams
                        );

                        setTimeout(function () {
                            $this._processing = false;
                            $this.finishTransaction.emit(data.clisitefStatus);
                            localStorage.removeItem("pending-transaction");
                            $this.setIcon($this.iconAprovado);
                        }, 1000);
                    }
                    //tratando mensagens de erro
                    else if (data.clisitefStatus == -1) {
                        $this.showStatus(
                            `(${data.clisitefStatus}) Módulo não inicializado. O PDV tentou chamar alguma rotina sem antes executar a função configura. <br> ${s}`
                        );
                    } else if (data.clisitefStatus == -2) {
                        $this.showStatus(
                            `(${data.clisitefStatus}) Operação cancelada pelo operador. <br> ${s}`
                        );
                    } else if (data.clisitefStatus == -6) {
                        $this.showStatus(
                            `(${data.clisitefStatus}) Operação cancelada pelo usuário (no pinpad). <br> ${s}`
                        );
                    } else if (data.clisitefStatus == -7) {
                        $this.showStatus(
                            `(${data.clisitefStatus}) Reservado. <br> ${s}`
                        );
                    } else if (data.clisitefStatus == -8) {
                        $this.showStatus(
                            `(${data.clisitefStatus}) A CliSiTef não possui a implementação da função necessária, provavelmente está desatualizada (a CliSiTefI é mais recente). <br> ${s}`
                        );
                    } else if (data.clisitefStatus == -9) {
                        $this.showStatus(`(${data.clisitefStatus})  A automação chamou a rotina ContinuaFuncaoSiTefInterativo sem antes iniciar uma
                        função iterativa. <br> ${s}`);
                    } else if (data.clisitefStatus == -10) {
                        $this.showStatus(
                            `(${data.clisitefStatus}) Algum parâmetro obrigatório não foi passado pela automação comercial. <br> ${s}`
                        );
                    } else if (data.clisitefStatus == -12) {
                        $this.showStatus(
                            `(${data.clisitefStatus})  Erro na execução da rotina iterativa. Provavelmente o processo iterativo anterior não foi executadoaté o final (enquanto o retorno for igual a 10000). <br> ${s}`
                        );
                    } else if (data.clisitefStatus == -13) {
                        $this.showStatus(
                            `(${data.clisitefStatus})  Documento fiscal não encontrado nos registros da CliSiTef. Retornado em funções de consulta tais como ObtemQuantidadeTransaçõesPendentes. <br> ${s}`
                        );
                    } else if (data.clisitefStatus == -15) {
                        $this.showStatus(
                            `(${data.clisitefStatus}) Operação cancelada pela automação comercial. <br> ${s}`
                        );
                    } else if (data.clisitefStatus == -5) {
                        $this.showStatus(
                            `(${data.clisitefStatus}) Sem comunicação com o SiTef. <br> ${s}`
                        );
                    } else if (data.clisitefStatus == -40) {
                        $this.showStatus(
                            `(${data.clisitefStatus}) Transação negada pelo servidor SiTef. <br> ${s}`
                        );
                    } else if (data.clisitefStatus == -43) {
                        $this.showStatus(
                            `(${data.clisitefStatus})  Problema na execução de alguma das rotinas no pinpad. <br> ${s}`
                        );
                    } else {
                        $this.showStatus(
                            `Finalizado - Retorno: (${data.clisitefStatus}).<br> ${s}`
                        );
                    }

                    $this.setIcon($this.iconOperacaoCancelada);
                    setTimeout(function () {
                        $this._processing = false;
                        $this.finishTransaction.emit();
                        localStorage.removeItem("pending-transaction");
                    }, 3000);

                    return;
                }

                if (data.commandId != 23) {
                    // tratamento para nao piscar a tela (refresh)
                    var lastContents23: any = "";
                }
                $this._commandId = data.commandId;
                console.log("comando " + $this._commandId);
                switch (data.commandId) {
                    case 0:
                        var item = {
                            TipoCampo: data.fieldId,
                            Valor: data.data,
                        };

                        // acumula o resultado em um JSON, pode ser usado no final da transação para POST ao servidor da automação
                        $this._sessao.ret.push(item);
                        // console.info("TipoCampo [" + data.fieldId + "] Valor[" + data.data + "]");

                        $this.setPendingTransaction();

                        if (data.fieldId == 121) {
                            localStorage.setItem("cupomLojaSitef", data.data);
                            //$this.showMessage("Cupom Estabelecimento: \n" + data.data);
                        }

                        if (data.fieldId == 122) {
                            localStorage.setItem(
                                "cupomClienteSitef",
                                data.data
                            );
                            //$this.showStatus("Cupom Cliente: \n" + data.data);
                        }

                        $this.continue("");
                        break;
                    case 1:
                    case 2:
                    case 3:
                    case 4:
                    case 15:
                        $this._statusTitle = data.data;

                        // $this._statusTitle =  $this._statusTitle
                        // .replace('Insira ou passe o cartao na leitora', 'Insira ou passe seu cartão')
                        // .replace('SOLICITE A SENHA', 'Digite sua senha no terminal')
                        // .replace('Retire o cartao da leitora', 'Retire o cartão');
                        $this.showStatus($this._statusTitle);
                        $this.continue("");

                        //Definindo ícones
                        if ($this._statusTitle == "Conectando Servidor") {
                            $this.setIcon($this.iconConectando);
                        } else if ($this._statusTitle == "Servidor Conectado") {
                            $this.setIcon($this.iconConectado);
                        } else if (
                            $this._statusTitle ==
                            "Insira ou passe o cartao na leitora"
                        ) {
                            $this.setIcon($this.iconInsiraCartao);
                        } else if ($this._statusTitle == "SOLICITE A SENHA") {
                            $this.setIcon($this.iconSenha);
                        } else if (
                            $this._statusTitle == "Retire o cartao da leitora"
                        ) {
                            $this.setIcon($this.iconRetiraCartao);
                        } else if (
                            $this._statusTitle
                                .toUpperCase()
                                .includes("SELECIONADO:")
                        ) {
                            $this.setIcon($this.iconSelecioneCartao);
                        } else {
                            $this.setIcon($this.iconProcessando);
                        }

                        break;
                    case 11:
                    case 12:
                    case 13:
                    case 14:
                    case 16:
                        //Apaga display
                        $this._statusTitle = "";
                        $this.continue("");
                        break;

                    case 22:
                        $this._statusTitle = data.data;
                        $this.showStatus($this._statusTitle);
                        // $this._statusBody =  $this.sanitized.bypassSecurityTrustHtml('<button type="button" class="btn btn-outline-success btn-lg bg-white text-primary-congress" (click)="continue("")"><i class="fa fa-check"></i><span style="font-weight: 600;">Ok</span></button>')

                        $this.setIcon($this.iconOperacaoCancelada);

                        //$this.continue("");
                        break;

                    case 23:
                        var contents = $this.sanitized.bypassSecurityTrustHtml(
                            '<button type="button" id="cancela" name="cancela" #cancela class="btn btn-outline-success btn-lg bg-white text-primary-congress" (click)="Window.agentComponent.cancel()"><i class="fa fa-close"></i><span style="font-weight: 600;">Cancelar</span></button>'
                        );
                        if (lastContents23 != contents) {
                            // $this._statusBody = contents;
                            lastContents23 = contents;
                        }

                        // No comando 23, faz o reset da flag de continuidade, para sensibilizar tratamento de confirmações de cancelamento da clisitef.
                        setTimeout(function () {
                            $this.continue("");
                            $this._sessao.continua = 0;
                        }, 500);

                        break;

                    case 20:
                        $this._statusTitle = data.data;

                        $this._statusTitle = $this._statusTitle.replace(
                            "13 - Operacao Cancelada?",
                            "13 - Cancelar operação?"
                        );

                        if (($this._statusTitle = "13 - Cancelar operação?")) {
                            $this.setIcon($this.iconInterrogacao);
                        }

                        $this.showStatus($this._statusTitle);
                        // $this._statusBody = $this.sanitized.bypassSecurityTrustHtml(
                        // '<button type="button" id="sim" name="sim" #sim class="btn btn-outline-success btn-lg bg-white text-primary-congress" (click)="continue(0)"><i class="fa fa-check"></i><span style="font-weight: 600;">Sim</span></button>' +
                        // '<button type="button" id="nao" name= "nao" #nao class="btn btn-primary-congress btn-lg bg-white text-primary-congress" (click)="continue(1)"><i class="fa fa-arrow-left"></i><span style="font-weight: 600;">Não</span></button>')

                        break;
                    case 21:
                    case 30:
                    case 31:
                    case 32:
                    case 33:
                    case 34:
                    case 35:
                    case 38:
                        var si = data.data;
                        if (data.commandId == 21){
                            si = si.replace(/;/g, "<br/>");
                        }

                            if (data.commandId == 30 && $this.parcelas > 1) {
                                //Define número de parcelas
                                $this.trataColeta(0, $this.parcelas);
                            } else if (
                                $this.parcelas > 1 &&
                                data.data.includes("Parcelado")
                            ) {
                                //Pula o passo de escolha do parcelamento 1 a vista, 2 pelo estabelecimento, 3 pela administradora, 4 consulta
                                $this.trataColeta(0, 2);
                            } else if (data.data.includes("Chip")) {
                                //1 - Magentico/chip 2 - Digitado
                                $this.trataColeta(0, 1);
                            } else {
                                //A vista
                                $this.trataColeta(0, 1);
                            }

                        // if($this._commandId == 21 || $this._commandId >= 30)
                        //    $this._statusBody = 'Parcelamento(' + ($this.parcelas > 1 ? $this.parcelas : 1) + ')';
                        break;
                    default:
                        $this._commandId = -1;
                        console.log("default");
                        $this._statusBody =
                            "Chegou uma captura desconhecida.[" +
                            data.commandId +
                            "]";
                        this.continue("");
                }
            })
            .fail(function (xhr, ajaxOptions, thrownError) {
                $this.showMessage(
                    `Erro: ${xhr.status} - ${thrownError} <br> ${xhr.responseText}`
                );
            });
    }

    trataTecla(event, dados) {
        if (event.keyCode == 0x0d) this.trataColeta(0, dados);
    }

    trataColeta(cont: number, dados: number) {
        this._sessao.continua = cont;
        this.continue(dados);
    }

    // ===========================================================================
    // Funcoes de PinPad

    pinpadOpen() {
        var $this = this;
        $this.showStatus("Abrindo pinpad...");

        $.ajax({
            url: this._agent_url + "/pinpad/open",
            type: "post",
            data: {
                sessionId: this._sessao.sessionId,
            },
        })
            .done(function (data) {
                if (data.serviceStatus != 0) {
                    $this.showMessage(
                        data.serviceStatus + " - " + data.serviceMessage
                    );
                } else if (data.clisitefStatus == 0) {
                    $this.showMessage("PinPad aberto com sucesso");
                } else {
                    $this.showMessage(
                        "Retorno " + data.clisitefStatus + " da CliSiTef"
                    );
                }
            })
            .fail(function (xhr, ajaxOptions, thrownError) {
                $this.showMessage(
                    `Erro: ${xhr.status} - ${thrownError} <br> ${xhr.responseText}`
                );
            });
    }

    pinpadFecha() {
        var $this = this;
        $this.showStatus("Fechando pinpad...");

        $.ajax({
            url: this._agent_url + "/pinpad/close",
            type: "post",
            data: {
                sessionId: this._sessao.sessionId,
            },
        })
            .done(function (data) {
                if (data.serviceStatus != 0) {
                    $this.showMessage(
                        data.serviceStatus + " - " + data.serviceMessage
                    );
                } else if (data.clisitefStatus == 0) {
                    $this.showMessage("PinPad fechado com sucesso");
                } else {
                    $this.showMessage(
                        "Retorno " + data.clisitefStatus + " da CliSiTef"
                    );
                }
            })
            .fail(function (xhr, ajaxOptions, thrownError) {
                $this.showMessage(
                    `Erro: ${xhr.status} - ${thrownError} <br> ${xhr.responseText}`
                );
            });
    }

    pinpadPresent() {
        var $this = this;
        $this.showStatus("Verificando presença do pinpad...");

        $.ajax({
            url: $this._agent_url + "/pinpad/isPresent",
            type: "post",
            data: {
                sessionId: $this._sessao.sessionId,
            },
        })
            .done(function (data) {
                $this.showStatus("Presença do pinpad");

                if (data.serviceStatus != 0) {
                    $this.showMessage(
                        data.serviceStatus + " - " + data.serviceMessage
                    );
                } else if (data.clisitefStatus == 0) {
                    $this.showMessage("PinPad ausente");
                } else if (data.clisitefStatus == 1) {
                    $this.showMessage("PinPad presente");
                } else {
                    $this.showMessage(
                        "Retorno " + data.clisitefStatus + " da CliSiTef"
                    );
                }
            })
            .fail(function (xhr, ajaxOptions, thrownError) {
                $this.showMessage(
                    `Erro: ${xhr.status} - ${thrownError} <br> ${xhr.responseText}`
                );
            });
    }

    pinpadMensagem(mensagem, persistente) {
        var $this = this;
        $this.showStatus("Escrevendo mensagem no pinpad...");

        $.ajax({
            url: $this._agent_url + "/pinpad/setDisplayMessage",
            type: "post",
            data: {
                sessionId: $this._sessao.sessionId,
                displayMessage: mensagem,
                persistent: persistente ? "Y" : "N",
            },
        })
            .done(function (data) {
                if (data.serviceStatus != 0) {
                    $this.showStatus("Mensagem no pinpad");
                    $this.showMessage(
                        data.serviceStatus + " - " + data.serviceMessage
                    );
                } else {
                    this.resetView();
                }
            })
            .fail(function (xhr, ajaxOptions, thrownError) {
                $this.showMessage(
                    `Erro: ${xhr.status} - ${thrownError} <br> ${xhr.responseText}`
                );
            });
    }

    pinpadLeSimNao(mensagem) {
        var $this = this;
        $this.showStatus("Obtendo escolha no pinpad...");

        $.ajax({
            url: this._agent_url + "/pinpad/readYesNo",
            type: "post",
            data: {
                sessionId: this._sessao.sessionId,
                displayMessage: mensagem,
            },
        })
            .done(function (data) {
                if (data.serviceStatus != 0) {
                    $this.showStatus("Retorno do pinpad");
                    $this.showMessage(
                        data.serviceStatus + " - " + data.serviceMessage
                    );
                } else if (data.clisitefStatus == 0) {
                    $this.showMessage("Tecla Anula pressionada");
                } else if (data.clisitefStatus == 1) {
                    $this.showMessage("Tecla Entra pressionada");
                } else {
                    $this.showMessage(
                        "Retorno " + data.clisitefStatus + " da CliSiTef"
                    );
                }
            })
            .fail(function (xhr, ajaxOptions, thrownError) {
                $this.showMessage(
                    `Erro: ${xhr.status} - ${thrownError} <br> ${xhr.responseText}`
                );
            });
    }

    showStatus(msg) {
        this._statusTitle = msg;
        this._statusBody = "";
    }

    showMessage(msg) {
        this._statusBody = this.sanitized.bypassSecurityTrustHtml(
            msg +
                '<br/><button type="button" id="reset" #reset name="reset" class="btn btn-primary-congress btn-lg bg-white text-primary-congress" (click)="resetView()"><i class="fa fa-check"></i><span style="font-weight: 600;">Ok</span></button>'
        );
    }

    resetView() {
        this._statusTitle = "";
        this._statusBody = "";
        if (!this._sessao.usandoSessao) {
            // Foi usada uma sessao temporária, faz a limpeza pois o servidor removeu a sessão
            this._sessao.sessionId = 0;
        }

        this._processing = false;
        localStorage.removeItem("pending-transaction");
    }

    cancel() {
        this._sessao.continua = -1;
        //this._processing = false;
    }

    //Set prnding transation for confitrmation or not
    setPendingTransaction() {
        var $this = this;
        let transaction: ITransaction = {
            cupomFiscal: $this.cupomFiscal,
            empresa: $this.empresa,
            sitefIp: $this.sitefIp,
            terminal: $this.terminal,
            initialParams: $this.initialParams,
        };

        localStorage.setItem(
            "pending-transaction",
            JSON.stringify(transaction)
        );
    }

    setIcon(icon: string) {
        this._paymentIcon = icon;
    }

    getCurrentTimeNums(): string {
        var d = new Date(); // for now
        let hour = d.getHours();
        let min = d.getMinutes();
        let sec = d.getSeconds();

        let newhour =
            hour.toString().length == 1 ? "0" + hour : hour.toString();
        let newmin = min.toString().length == 1 ? "0" + min : min.toString();
        let newsec = sec.toString().length == 1 ? "0" + sec : sec.toString();

        return newhour + newmin + newsec;
    }

    getCurrentDateNums(): string {
        var d = new Date(); // for now
        let day = d.getDay();
        let month = d.getMonth();
        let year = d.getFullYear();

        let formatDay = day.toString().length == 1 ? "0" + day : day.toString();
        let formatMonth =
            month.toString().length == 1 ? "0" + month : month.toString();
        let formatYear =
            year.toString().length == 1 ? "0" + year : year.toString();

        return formatYear + formatMonth + formatDay;
    }

    clearSitefStorage() {
        localStorage.removeItem("cupomClienteSitef");
        localStorage.removeItem("cupomLojaSitef");
        localStorage.removeItem("dadosSitef");
        localStorage.removeItem("pending-transaction");
    }
}



// WEBPACK FOOTER //
// ./src/congress/shared/layout/checkout/agent-sitef/agent-sitef.component.ts